import { awsApiInstance } from '../api/aws-api';

import { INewCards, IPostCardsResponse } from '../models/cards.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Post a new card
 * 
 * @param {INewCards} cards the form data
 * 
 * @returns {IPostCardsResponse} the api response | error
 */
const AwsPostNewCards = async (cards: INewCards): Promise<IPostCardsResponse> => {
  try {
    const { data } = await awsApiInstance.post('/cards', cards);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error creating new cards');
    throw(error);
  }
}

export default AwsPostNewCards;